import axios from 'axios';

const SERVICE_URL_USERS = '/usuarios';

const RECEIVE_USERS = 'RECEIVE_USERS';
const TOTAL_USERS = 'TOTAL_USERS';
const SET_ACTUAL_CONTRACT = 'SET_ACTUAL_CONTRACT';
const SET_USERS_FAENA = 'SET_USERS_FAENA';

// Helper
function axiosConfig() {
  return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}


const state = {
  actualContract: JSON.parse(localStorage.getItem('actualContract')),
  users: [],
  usersFaena: [],
  totalUsers: 0,
};


const getters = {
  actualContract: state => state.actualContract,
  users: state => state.users,
  usersFaena: state => state.usersFaena,
  totalUsers: state => state.totalUsers,
};


const actions = {

  async getUsersFaena({ commit }, faenaId) {
    try {
      const url = `${SERVICE_URL_USERS}/users-faena-with-roles/${faenaId}`;

      const response = await axios.get(url, axiosConfig());
      if (response.data && response.data.usersFaena) {
        commit(SET_USERS_FAENA, response.data.usersFaena);
        return true;
      }
      return false;
    } catch (e) {
      console.log(e);
      return false;
    }
  },


  userExists({ commit }, body) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
    return axios
      .post(`${SERVICE_URL_USERS}/user_exists`, body, config)
      .then((response) => {
        if (response.data.success) {
          return true;
        }
        return false;
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },


  async createUser({ commit }, user) {
    const response = await axios.post(
      `${SERVICE_URL_USERS}/create-user`,
      user,
      axiosConfig(),
    );
    if (response && response.data && response.data.success) { return response.data; }
    return false;
  },

  async updateUser({ commit }, user) {
    const response = await axios.post(
      `${SERVICE_URL_USERS}/update-user`,
      user,
      axiosConfig(),
    );
    return !!((response && response.data && response.data.success));
  },

  async updateUsersRoles({ commit }, roles) {
    const response = await axios.post(
      `${SERVICE_URL_USERS}/update-users-permissions`,
      roles,
      axiosConfig(),
    );
    return !!((response && response.data && response.data.success));
  },

  async addRolesToUser({ commit }, roles) {
    const response = await axios.post(
      `${SERVICE_URL_USERS}/add-ac-permissions-to-user`,
      roles,
      axiosConfig(),
    );
    return !!((response && response.data && response.data.success));
  },


  saveUser({ commit }, nuevo) {
    nuevo.createdFrom = 'inventarios';
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(`${SERVICE_URL_USERS}/crear`, nuevo, config).then((response) => {
        if (!response.data.success) {
          resolve({
            success: false,
            message: response.data.message,
          });
        } else {
          resolve({
            success: true,
          });
        }
      });
    });
  },


  editUser({ commit }, user) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(`${SERVICE_URL_USERS}/edit/${user.id}`, user.body, config).then((response) => {
        if (!response.data.success) {
          resolve({
            message: response.data.message,
            success: false,
          });
        } else {
          resolve({
            success: true,
          });
        }
      });
    });
  },

  deleteUser({ commit }, user) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.delete(SERVICE_URL_USERS + user.id, config).then((response) => {
        if (!response.data.success) {
          resolve({
            message: response.data.message,
            success: false,
          });
        } else {
          resolve({
            success: true,
          });
        }
      });
    });
  },

  setActualContract({ commit }, contract) {
    localStorage.setItem('actualContract', JSON.stringify(contract));
    commit(SET_ACTUAL_CONTRACT, contract);
  },


};

const mutations = {
  [SET_USERS_FAENA](state, usersFaena) {
    state.usersFaena = usersFaena;
  },
  [RECEIVE_USERS](state, users) {
    state.users = users;
  },
  [TOTAL_USERS](state, total) {
    state.totalUsers = total;
  },
  [SET_ACTUAL_CONTRACT](state, contract) {
    state.actualContract = contract;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
